import { AppQueryParams } from '@doda/common/src/constants/queryParams';
import { NE_SEARCH_ITEMS } from '@doda/common/src/constants/searchItems';
import { EmployNumRequestCode } from '@doda/api-client/aspida/@types';

/**
 * 従業員数のAPIリクエスト作成
 * @param queryParams クエリパラメータ
 * @returns 従業員数のAPIリクエスト
 */
export const createEmployNumApiRequest = (queryParams: AppQueryParams) => {
  let employNumName = '';
  let ne = '';

  if (queryParams.ne) [ne] = queryParams.ne;
  const findNe = NE_SEARCH_ITEMS.find((option) => option.id === ne);
  if (findNe && findNe.seoText) {
    employNumName = findNe.seoText;
  } else {
    // マスタに存在する値かの判定
    throw new Error('パラメータの不正(ne)');
  }
  const requestEmployNumId = queryParams.ne as
    | EmployNumRequestCode[]
    | undefined;

  return { employNumName, requestEmployNumId };
};
